import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuestionnaire } from "@/context/QuestionnaireContext";

export default function Resume() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { startResume } = useQuestionnaire();

  useEffect(() => {
    if (id) {
      startResume(id);
      navigate("/privacy", { replace: true });
    }
  }, [id, startResume, navigate]);

  return (
    <div className="min-h-[100dvh] grid place-items-center bg-background">
      <div className="h-8 w-8 rounded-full border-2 border-foreground/20 border-t-foreground animate-spin" />
    </div>
  );
}
